module.exports = __webpack_public_path__ + "static/media/view progress report.d9b6b69a.svg";